<template lang="pug">
list-manager(:loading="loading" :error="error" :paginated-list="list" @fetch-data="fetchData")
  div(v-if="list && list.rows.length > 0")
    .columns.my-2.py-2.align-center(v-for="item in list.rows")
      .column.col-2.column-cover
        img.img-cover.img-responsive(:src="item.productItem.cover || require('@/assets/video-thumbnail-default.png')")
      .column
        .text-bold {{ item.productItem.title }}
        .text Tempo assistido: #[b ≅ {{ watchedMinutes(item.secondsWatched) }} {{ watchedMinutes(item.secondsWatched) > 1 ? 'minutos' : 'minuto' }}]
</template>

<script>
import filiationBalances from '@/services/filiationBalances'

export default {
  data() {
    return {
      list: null,
      loading: false,
      error: null,
    }
  },
  methods: {
    async fetchData(params = {}) {
      try {
        this.loading = true
        const { data } = await filiationBalances.videoWatches(
          this.balance.id,
          params,
        )
        this.list = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
    watchedMinutes(seconds) {
      return Math.round(seconds / 60)
    },
  },
  props: { balance: { type: Object, required: true } },
  created() {
    this.fetchData()
  },
}
</script>

<style lang="stylus" scoped>
.columns
  border-bottom 1px solid #eee
  &:last-child
    border-bottom none
  .column-cover
    min-width 70px
.img-cover
  border-radius 5px
</style>
